<div [ngClass]="responsiveService.getBigSmall()">

    <div class="whoo-left-right context-bar-container">
        <div class="left context-bar-item">
            <!--up button: always navigates to My Events, never a history pop — view
                switching inside the poll has its own preview/dashboard buttons, real
                back-paging is the browser's job.-->
            <button mat-button class="navigation-button" (click)="navigateUp()"
                [attr.aria-label]="trans.translate('actionLabels.home')"
                matTooltip="{{trans.translate('actionLabels.home')}}">
                <mat-icon class="icon">navigate_before</mat-icon>
                <span
                    *ngIf="routeContextService.title && responsiveService.isScreenBig()">{{trans.translate('actionLabels.home')}}</span>
            </button>

        </div>
        <div *ngIf="routeContextService.title" class="middle context-bar-item">
            <span>{{routeContextService.title}}</span>
        </div>
        <span class="right context-bar-item">

            <!--BIG SCREEN — same sequence as the kebab: edit actions, navigation, utilities,
                lifecycle with delete last (material/iOS convention)-->
            <span *ngIf=" !responsiveService.isScreenSmall()" class="button-bar whoo-normal-button">

                <!--shareEvent: the only button of the bar with a label, so it stops looking
                    like the row of icons next to it. One click, no sub menu — except on
                    pollResponses, where the button expands into vote link vs. result matrix.
                    Hidden while the share panel on votePreview owns the share entry point.
                    Label "participant link" (workorder 1.12, Kai D2): it stands next to the
                    organizer link, so the bar shows that there are two links and which is which.-->
                <button *ngIf="showShareEntry && !isPollResponses" mat-stroked-button color="primary"
                    class="share-button" (click)="sharePoll()"
                    matTooltip="{{trans.translate('actionLabels.shareEvent')}}">
                    <mat-icon class="share-icon">ios_share</mat-icon>
                    <span>{{trans.translate('actionLabels.share' )}}</span>
                </button>

                <!--expandable share: only where a response matrix exists both share targets
                    live behind one button (menu defined once at the end of the file) - so it keeps
                    the plain verb, the entries inside name what they share-->
                <button *ngIf="isPollResponses" mat-stroked-button color="primary" class="share-button"
                    [matMenuTriggerFor]="shareMenu">
                    <mat-icon class="share-icon">ios_share</mat-icon>
                    <span>{{trans.translate('actionLabels.shareMenu' )}}</span>
                    <mat-icon iconPositionEnd class="share-caret">arrow_drop_down</mat-icon>
                </button>


                <!--navigate editPoll — big-screen anchor of the toolbar coachmark: the bar has
                    no kebab here, and edit is the first thing the hint text names. The two edit
                    buttons are route-exclusive, so exactly one of them owns the popup.-->
                <button *ngIf="routeContextService.id !=='editPoll' && routeContextService.id !=='votePreview' "
                    mat-icon-button (click)="editPoll()" matTooltip="{{trans.translate('actionLabels.edit' )}}"
                    aria-label="Edit" [bdcWalkTriggerFor]="hintActionBar" [enabled]="showActionBarHint">
                    <mat-icon class="icon">edit_outline</mat-icon>
                </button>

                <!--open sidebar to edit-->
                <button *ngIf="routeContextService.id ==='votePreview'  || routeContextService.id ==='editPoll'"
                    mat-icon-button color="primary" matTooltip="{{trans.translate('actionLabels.edit' )}}"
                    aria-label="Edit" (click)="contextActionBarService.triggerEditPollSettings()"
                    [bdcWalkTriggerFor]="hintActionBar" [enabled]="showActionBarHint">
                    <mat-icon class="icon">edit</mat-icon>
                </button>

                <!--add option-->
                <add-option-button *ngIf="routeContextService.id ==='votePreview'" appearance="icon" color="primary"
                    (onAddOption)="contextActionBarService.triggerAddOption($event)"></add-option-button>

                <!--pollResponses-->
                <button *ngIf="routeContextService.id !=='pollResponses'" mat-icon-button color="primary"
                    (click)="openPollOverview()" matTooltip="{{trans.translate('actionLabels.dasboard' )}}">
                    <mat-icon class="icon">insert_chart</mat-icon>
                </button>

                <!--preview-->
                <button *ngIf="routeContextService.id !=='votePreview'" mat-icon-button color="primary"
                    (click)="openVotePage()" matTooltip="{{trans.translate('actionLabels.preview' )}}">
                    <mat-icon class="icon">preview</mat-icon>
                </button>

                <!--downloadCalendarEntries: exactly one date → the add-to-calendar menu (Google / Outlook / .ics,
                    decision K2), several → all as .ics, none → the "no dates" dialog (handleClickCalendar)-->
                <button *ngIf="calendarEventCount === 1" mat-icon-button color="primary"
                    [matMenuTriggerFor]="calendarItems.menu" (menuOpened)="icalService.prepareAccessLink()"
                    matTooltip="{{trans.translate('voteResponse.calendarAddButton')}}">
                    <mat-icon class="icon" svgIcon="calendar-export"></mat-icon>
                </button>
                <button *ngIf="calendarEventCount !== 1" mat-icon-button color="primary" (click)="handleClickCalendar()"
                    matTooltip="{{trans.translate('actionLabels.downloadCalendarEntries' )}}">
                    <mat-icon class="icon" svgIcon="calendar-export"></mat-icon>
                </button>

                <!--personalAccess: the organizer link - for everyone who may organize the event (owner, legacy
                    delegate, co-organizer), signed in or anonymous (poll-scoped access 1.10); the only way to
                    bring in co-organizers since 1.9-->
                <button mat-icon-button *ngIf="currentPollService.canManage" color="primary"
                    (click)="getAccessDialog()" matTooltip="{{trans.translate('actionLabels.personalAccess' )}}">
                    <mat-icon class="icon">key</mat-icon>
                </button>

                <!--close / reopen poll-->
                <button mat-icon-button color="primary" (click)="togglePollClosed()"
                    matTooltip="{{trans.translate(isClosed ? 'actionLabels.reopenPoll' : 'actionLabels.closePoll')}}">
                    <mat-icon class="icon">{{isClosed ? 'lock_open' : 'lock'}}</mat-icon>
                </button>

                <!--delete — last icon, so the destructive action never sits between the
                    everyday ones; owner, legacy delegate and co-owner only (an editor may not delete)-->
                <button *ngIf="currentPollService.canManage" mat-icon-button color="primary" (click)="deletePoll()"
                    matTooltip="{{trans.translate('actionLabels.delete' )}}">
                    <mat-icon class="icon">delete_outline</mat-icon>
                </button>
            </span>



            <!--SMALL SCREEN-->
            <ng-container *ngIf="responsiveService.isScreenSmall()">
                <!--visible share button on every context bar route, so sharing never hides in the
                    kebab; on pollResponses it opens the same two-entry menu as on big screens-->
                <button *ngIf="showShareEntry && !isPollResponses" mat-icon-button color="primary"
                    (click)="sharePoll()" matTooltip="{{trans.translate('actionLabels.shareEvent')}}"
                    attr.aria-label="{{trans.translate('actionLabels.shareEvent')}}">
                    <mat-icon color="primary">ios_share</mat-icon>
                </button>
                <button *ngIf="isPollResponses" mat-icon-button color="primary" [matMenuTriggerFor]="shareMenu"
                    attr.aria-label="{{trans.translate('actionLabels.shareMenu')}}">
                    <mat-icon color="primary">ios_share</mat-icon>
                </button>

                <!--menu — small-screen anchor of the toolbar coachmark: everything the hint
                    text names (edit, close, calendar export) lives behind this button.
                    Four frequency groups separated by dividers: editing, navigation,
                    utilities, lifecycle. The dividers sit in front of groups 2-4, each of
                    which always renders at least one item — navigation shows dashboard or
                    preview on every kebab route, calendar and close are unconditional — so
                    no leading or doubled divider can appear on any route.-->
                <span class="menu-button">
                    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu"
                        [bdcWalkTriggerFor]="hintActionBar" [enabled]="showActionBarHint">
                        <mat-icon color="primary">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">

                        <!--group 1: editing-->

                        <!--shareEvent-->
                        <button *ngIf="showShareEntry && !isPollResponses" mat-menu-item (click)="sharePoll()">
                            <mat-icon>ios_share</mat-icon>
                            <span>{{trans.translate('actionLabels.shareEvent' )}}</span>
                        </button>

                        <!--share sub menu: same two-entry menu the visible share button uses-->
                        <button *ngIf="isPollResponses" mat-menu-item [matMenuTriggerFor]="shareMenu">
                            <mat-icon>ios_share</mat-icon>
                            <span>{{trans.translate('actionLabels.shareMenu')}}</span>
                        </button>

                        <!--navigate editPoll-->
                        <button mat-menu-item (click)="editPoll()"
                            *ngIf="routeContextService.id !=='editPoll'  && routeContextService.id !=='votePreview'">
                            <mat-icon>edit</mat-icon>
                            <span>{{trans.translate('actionLabels.edit')}}</span>
                        </button>

                        <!--open sideNav to edit-->
                        <button mat-menu-item *ngIf="routeContextService.id ==='votePreview'"
                            (click)="contextActionBarService.triggerEditPollSettings()">
                            <mat-icon>edit</mat-icon>
                            <span>{{trans.translate('actionLabels.edit')}}</span>
                        </button>

                        <!-- Add with sub menu — votePreview only, mirroring the big-screen
                            add-option-button: elsewhere no vote component listens to
                            triggerAddOption. Trigger and menu share the *ngIf so the
                            template reference never outlives its trigger.-->
                        <ng-container *ngIf="routeContextService.id ==='votePreview'">
                            <button mat-menu-item [matMenuTriggerFor]="subMenu">
                                <mat-icon>add</mat-icon>
                                <span>{{'options.buttonAdd' | transTemplate | async}}</span>
                            </button>
                            <!--add sub-menu-->
                            <mat-menu #subMenu="matMenu">
                                <button *ngFor="let configKey of templateService.getOptionConfigKeys(false)"
                                    mat-menu-item (click)="contextActionBarService.triggerAddOption(configKey)">
                                    <span>{{templateService.getOptionConfigKeyLabel(configKey)}}</span>
                                </button>
                            </mat-menu>
                        </ng-container>

                        <!--group 2: navigation-->
                        <mat-divider></mat-divider>

                        <!--dashboard-->
                        <button mat-menu-item (click)="openPollOverview()"
                            *ngIf="routeContextService.id !=='pollResponses'">
                            <mat-icon>insert_chart</mat-icon>
                            <span>{{trans.translate('actionLabels.dasboard')}}</span>
                        </button>

                        <!--preview-->
                        <button mat-menu-item (click)="openVotePage()" *ngIf="routeContextService.id !=='votePreview'">
                            <mat-icon>preview</mat-icon>
                            <span>{{trans.translate('actionLabels.preview')}}</span>
                        </button>

                        <!--group 3: utilities-->
                        <mat-divider></mat-divider>

                        <!--downloadCalendarEntries: one date → sub menu with the add-to-calendar entries, otherwise as above-->
                        <button *ngIf="calendarEventCount === 1" mat-menu-item [matMenuTriggerFor]="calendarItems.menu"
                            (menuOpened)="icalService.prepareAccessLink()">
                            <mat-icon svgIcon="calendar-export"></mat-icon>
                            <span>{{trans.translate('voteResponse.calendarAddButton')}}</span>
                        </button>
                        <button *ngIf="calendarEventCount !== 1" mat-menu-item (click)="handleClickCalendar()">
                            <mat-icon svgIcon="calendar-export"></mat-icon>
                            <span>{{trans.translate('actionLabels.downloadCalendarEntries')}}</span>
                        </button>

                        <!--personalAccess: the organizer link, canManage like the desktop icon (1.10)-->
                        <button mat-menu-item *ngIf="currentPollService.canManage"
                            (click)="getAccessDialog()">
                            <mat-icon>key</mat-icon>
                            <span>{{trans.translate('actionLabels.personalAccess')}}</span>
                        </button>

                        <!--group 4: lifecycle-->
                        <mat-divider></mat-divider>

                        <!--close / reopen poll-->
                        <button mat-menu-item (click)="togglePollClosed()">
                            <mat-icon>{{isClosed ? 'lock_open' : 'lock'}}</mat-icon>
                            <span>{{trans.translate(isClosed ? 'actionLabels.reopenPoll' :
                                'actionLabels.closePoll')}}</span>
                        </button>

                        <!--delete — last entry, away from edit and close; canManage only-->
                        <button *ngIf="currentPollService.canManage" mat-menu-item (click)="deletePoll()">
                            <mat-icon>delete</mat-icon>
                            <span>{{trans.translate('actionLabels.delete')}}</span>
                        </button>
                    </mat-menu>
                </span>
            </ng-container>

        </span>
    </div>
</div>

<!--shared share menu (pollResponses only): one definition for its three triggers — the
    labelled big-screen button, the small-screen icon button and the kebab sub menu entry.
    matMenuContent keeps the content lazy, the documented pattern for multi-trigger menus.-->
<mat-menu #shareMenu="matMenu">
    <ng-template matMenuContent>
        <!--shareEvent: participant link dialog-->
        <button mat-menu-item (click)="sharePoll()">
            <mat-icon>ios_share</mat-icon>
            <span>{{trans.translate('actionLabels.shareEvent')}}</span>
        </button>
        <!--shareResultMatrix: copies the matrix url. Hidden when showParticipants is off:
            the rules deny recipients the votes list read, the link would show an empty matrix.
            One gate covers all three menu triggers (shared matMenuContent), and shareEvent
            stays, so the menu is never empty.-->
        <button mat-menu-item (click)="shareResult()" *ngIf="showShareResultMatrix">
            <mat-icon>table_view</mat-icon>
            <span>{{trans.translate('actionLabels.shareResultMatrix')}}</span>
        </button>
    </ng-template>
</mat-menu>

<!--the add-to-calendar entries (Google / Outlook / .ics, all dates of the poll), defined once for the calendar icon and
    the kebab entry; shown only when the poll has exactly one date (calendarEventCount)-->
<add-to-calendar-menu-items #calendarItems="calendarMenuItems" scope="all"></add-to-calendar-menu-items>

<!--the trigger sits on the tools themselves, not on the labelled share button: the kebab on
    small screens, the edit icon on big ones (no kebab there). Both sit inside the icon group,
    so the popup needs no horizontal offset to line up with its anchor.-->
<bdc-walk-popup #hintActionBar [xPosition]="responsiveService.isScreenSmall()?'before':'after'" [showCloseButton]="true"
    [showButton]="true" buttonText="{{'vote.hintStandardButton' | transTemplate | async}}"
    class="whoo-bdc-walk-popup whoo-bdc-walk-popup-mobile-right" [alignCenter]="false" name="hintActionBar"
    header=" {{'previewHint.hintActionBar' | transTemplate | async}}" [arrow]="true">
    {{'previewHint.hintActionBarDetails' | transTemplate | async}}
</bdc-walk-popup>
